import { render, staticRenderFns } from "./P_customTable.vue?vue&type=template&id=5c4a0fc2&scoped=true"
import script from "./P_customTable.vue?vue&type=script&lang=js"
export * from "./P_customTable.vue?vue&type=script&lang=js"
import style0 from "./P_customTable.vue?vue&type=style&index=0&id=5c4a0fc2&prod&lang=less&scoped=true"
import style1 from "./P_customTable.vue?vue&type=style&index=1&id=5c4a0fc2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4a0fc2",
  null
  
)

export default component.exports